import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { CourseUpdateRequestModel } from "../CourseUpdateRequestModel";

@Injectable()
export class DataService_CourseSetup {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	LoadCourse(SchoolID) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/LoadCourses?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LoadCourseTypes() {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/LoadCourseTypes?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UpdateCourses(parms: CourseUpdateRequestModel) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/UpdateCourses";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
